__turbopack_context__.v({
  "active": "Tabs-module__p-Q6ZW__active",
  "tab": "Tabs-module__p-Q6ZW__tab",
  "tabs": "Tabs-module__p-Q6ZW__tabs",
});
